export const TRACK_EVENTS = {
  ENTER_ROOM: "ENTER_ROOM",
  LOCATION_CHANGE: "LOCATION_CHANGE",
  TAKE_SEAT: "TAKE_SEAT",
  TOUR_START: "TOUR_START",
  TOUR_JOIN: "TOUR_JOIN",
  END_TOUR: "END_TOUR",
  USER_CHANGING_SCENE: "USER_CHANGING_SCENE",
  MOVED_CAMERA: "MOVED_CAMERA",
  CAMERA_OVER_OBJECT: "CAMERA_OVER_OBJECT",
  STARTED_VAPI: "STARTED_VAPI",
  TALKED_WITH_VAPI: "TALKED_WITH_VAPI",
  SESSION_OVER: "SESSION_OVER",
};
